<template>
  <b-modal ref="PackageModal" @hidden="hiddenModal"
           :no-close-on-backdrop="true" :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">{{$t('labels.pellets.title')}}</h5>
      <button type="button" aria-label="Close" class="close" tabindex="-1" @click="closeModal">×</button>
    </template>
    <slot></slot>
    <div>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.product')}}</label>
          <div class="d-flex">
            <multiselect v-model="packageData.product" :max-height="200" placeholder=""
                         :tabindex="1"
                         @search-change="asyncProductsSearch" label="name" track-by="id"
                         :loading="isLoadingProducts" @select="fetchProductData"
                         select-label="" deselect-label="" selected-label=""
                         :options="products" :disabled="!operationId"></multiselect>
            <div class="icons-group" @click="createProduct(packageData.product)"
                 title="Edit/create product">
              <icon name="pencil-alt"></icon>
            </div>
            <div class="icons-group" id="add-to-favorite" @click="openPackageTemplateNameDialog"
                 title="Add to favorite" :disabled="!packageData.product">
              <icon name="star"></icon>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="package-params">
          <div v-if="!isHiddenFields('package_nr')">
            <label>{{$t('labels.common.package_nr')}}</label>
            <input class="form-control" v-model="packageData.package_nr" :tab-index="2"
                   :disabled="isNotEditablePackageField('package_nr')" :tabindex="2">
          </div>
          <div v-if="!isHiddenFields('group')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.group')}}</label>
            <div>
              <multiselect
                  v-model="packageData.group" :max-height="200" label="name"
                  track-by="id" placeholder="" :options="groups"
                  :disabled="isNotEditablePackageField('group')"
                  :class="{ required: !packageData.group}"
                  select-label="" deselect-label="" selected-label=""
                  :tabindex="3">
              </multiselect>
            </div>
          </div>
          <div v-if="!isHiddenFields('tree')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.wood')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.tree" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="wood"
                           :disabled="isNotEditablePackageField('tree')"
                           :class="{ required: !packageData.tree}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="5"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('tree')"
                   title="Apply selected tree to all packages"
                   v-show="operationId && !isNotEditablePackageField('tree')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('diameter')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.pellets.diameter')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.diameter" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="pellet_diameters"
                           :disabled="isNotEditablePackageField('diameter')"
                           :class="{ required: !packageData.diameter}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="4"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('diameter')"
                   title="Apply selected diameter to all packages"
                   v-show="operationId && !isNotEditablePackageField('diameter')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('package_type')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.package_type')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.package_type" :max-height="200" label="name"
                           track-by="name" placeholder="" :options="packageTypes"
                           :class="{ required: !packageData.package_type}"
                           select-label="" deselect-label="" selected-label=""
                           :disabled="isNotEditablePackageField('package_type')"
                           :tabindex="11">
              </multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('package_type')"
                   title="Apply selected packaging to all packages"
                   v-show="operationId && !isNotEditablePackageField('package_type')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('pallet_size')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.pellets.pallet_size')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.pallet_size" :max-height="200" placeholder=""
                           label="name" track-by="id"
                           :options="pallet_sizes" :disabled="isNotEditablePackageField('pallet_size')"
                           :class="{ required: !packageData.pallet_size}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="8"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('pallet_size')"
                   title="Apply selected pallet size to all packages"
                   v-show="operationId && !isNotEditablePackageField('pallet_size')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('bag_logo')">
            <label class="important-field" title="This field is required to completing operation">{{$t('labels.pellets.bag_logo')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.bag_logo" :max-height="200" :options="bag_logos"
                           placeholder="" label="name" track-by="id"
                           :class="{ required: !packageData.bag_logo}"
                           :disabled="isNotEditablePackageField('bag_logo')"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="8"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('bag_logo')"
                   title="Apply selected back logo to all packages"
                   v-show="operationId && !isNotEditablePackageField('bag_logo')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="package-params">
          <div v-if="!isHiddenFields('quality')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.quality')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.quality" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="qualities_list"
                           :disabled="isNotEditablePackageField('quality')"
                           :class="{ required: !packageData.quality}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="7"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('quality')"
                   title="Apply selected quality to all packages"
                   v-show="operationId && !isNotEditablePackageField('quality')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('wood_certificate')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.certificate')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.wood_certificate" :max-height="200" label="name"
                           track-by="name" placeholder="" :options="wood_certificates"
                           :disabled="isNotEditablePackageField('wood_certificate')"
                           select-label="" deselect-label="" selected-label=""
                           :class="{ required: !packageData.wood_certificate}"
                           :tabindex="10" :allow-empty="false">
              </multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('wood_certificate', 'id')"
                   title="Apply selected certificate to all packages"
                   v-show="operationId && !isNotEditablePackageField('wood_certificate')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('stock_address')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.stock')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.stock_address" :max-height="200" label="name"
                           track-by="id" placeholder="" :options="stock_addresses"
                           :disabled="isNotEditablePackageField('stock_address')"
                           :class="{ required: !packageData.stock_address}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="12"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('stock_address')"
                   title="Apply selected stock to all packages"
                   v-show="operationId && !isNotEditablePackageField('stock_address')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('partner')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.supplier')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.partner" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="partners"
                           :disabled="isNotEditablePackageField('partner')"
                           :class="{ required: !packageData.partner}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="13"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('partner')"
                   title="Apply selected provider to all packages"
                   v-show="operationId && !isNotEditablePackageField('partner')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div>
            <label>{{$t('labels.common.comment')}}</label>
            <div class="d-flex">
              <input class="form-control" v-model="packageData.comment" :disabled="isNotEditablePackageField('comment')"
                     tabindex="14">
              <div class="reply-icon-wrapper" @click="applyToAllPackages('comment', null)"
                   title="Apply selected comment to all packages"
                   v-show="operationId && !isNotEditablePackageField('comment')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="total-params pallets-params">
          <div v-if="!isHiddenFields('unit_weight')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.pellets.unit_weight')}}</label>
            <input type="number"
                   class="form-control"
                   v-model="packageData.unit_weight"
                   min="0"
                   @input="calculateTotalWeight"
                   :disabled="isNotEditablePackageField('unit_weight')"
                   :class="{required: !packageData.unit_weight}"
                   tabindex="15">
          </div>
          <div v-if="!isHiddenFields('pieces')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.quantity')}}</label>
            <input type="number"
                   class="form-control"
                   v-model="packageData.pieces"
                   min="0"
                   @input="calculateTotalWeight"
                   :disabled="isNotEditablePackageField('pieces')"
                   :class="{required: !packageData.pieces}"
                   tabindex="16">
          </div>
          <div>
            <label>{{$t('labels.pellets.total_weight')}}</label>
            <input
                type="number"
                class="form-control"
                v-model="packageData.weight" disabled>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-popover target="package-creating" placement="bottom" ref="package-creating-popover">
      <div>
        <b-btn size="sm" class="full-width" title="Create pellet package" @click="openPackageForm('pellets')">
          {{$t('labels.pellets.pellet')}}
        </b-btn>
      </div>
      <div class="d-flex margin-top-5" v-if="!packageData.isNew">
        <input type="number" ref="copies-count" value="1" class="form-control margin-right-5" min="0">
        <b-btn size="sm" class="full-width" @click="createCopies" title="Create copies of package">
          {{$t('buttons.packages.copies')}}
        </b-btn>
      </div>
    </b-popover>
    <div slot="modal-footer" class="w-100 text-center">
      <div class="button-group margin-0" v-if="operationId">
        <b-btn size="sm" variant="warning" id="package-creating">
          {{$t('buttons.common.create')}}
        </b-btn>
        <b-btn size="sm" variant="outline-primary" title="Create package based on changes"
               v-if="!packageData.isNew" @click="createBasedOnChanges">
          {{$t('buttons.common.create_based_on_changes')}}
        </b-btn>
        <b-btn size="sm" @click="save" variant="outline-success">
          {{$t('buttons.common.save')}}
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import { handlerResponse, setNotifyData, isObject } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { Decimal } from 'decimal.js';

  export default {
    props: ['fetchCallback', 'operationId'],
    components: {
      Multiselect
    },
    data() {
      return {
        isLoadingProducts: false,
        packageData: {},
        initialPackageData: {
          package_nr: '',
          product: null,
          package_type: null,
          wood_certificate: null,
          group: null,
          partner: null,
          serial_nr: '',
          tree: null,
          stock_address: null,
          comment: '',
          quality: null,
          amount: 0,
          pre_purchase_order: null,
          editable: null,
          unit_weight: null,
          pieces: null,
          weight: null,
          pallet_size: null,
          bag_logo: null,
          diameter: null,
          subpackages: []
        },
        products: [],
        purchase_orders: [],
        currentTabIndex: 0
      }
    },
    methods: {
      asyncProductsSearch(query) {
        if (query) {
          const params = {
            limit: 50,
            offset: 0,
            text: query
          };
          this.isLoadingProducts = true;
          this.$http.get(`woodware/list/search_for_product_short_view/`, {params}).then(handlerResponse)
            .then(response => {
              this.isLoadingProducts = false;
              this.products = response.results;
            });
        }
      },
      fetchProductData(selectedProduct) {
        const id = selectedProduct.id;
        if (id) {
          this.$http.get(`woodware/products/${id}/`).then(handlerResponse).then((response) => {
            delete response.id;
            for (let [key, value] of Object.entries(response)) {
              if (!this.isHiddenFields(key) && !this.isNotEditablePackageField(key)) {
                this.packageData[key] = value;
              }
            }
            this.calculateTotalWeight();
          });
        }
      },
      async fetchPurchaseOrders() {
        try {
          this.purchase_orders = await this.$http.get(`woodware/list/purchase_orders/`).then(handlerResponse);
        } catch (e) {
          console.log(e);
        }
      },
      prepareSavedPackageData() {
        return {
          movement: this.operationId,
          bag_logo: this.packageData.bag_logo && this.packageData.bag_logo.id,
          comment: this.packageData.comment,
          diameter: this.packageData.diameter && this.packageData.diameter.id,
          group: this.packageData.group && this.packageData.group.id,
          package_nr: this.packageData.package_nr,
          package_type: this.packageData.package_type && this.packageData.package_type.id,
          pallet_size: this.packageData.pallet_size && this.packageData.pallet_size.id,
          partner: this.packageData.partner && this.packageData.partner.id,
          pieces: +this.packageData.pieces,
          pre_purchase_order: this.packageData.pre_purchase_order && this.packageData.pre_purchase_order.id,
          quality: this.packageData.quality && this.packageData.quality.id,
          serial_nr: this.packageData.serial_nr || null,
          stock_address: this.packageData.stock_address && this.packageData.stock_address.id,
          tree: this.packageData.tree && this.packageData.tree.id,
          unit_weight: this.packageData.unit_weight,
          wood_certificate: this.packageData.wood_certificate && this.packageData.wood_certificate.id
        }
      },
      calculateTotalWeight() {
        const {unit_weight, pieces} = this.packageData;
        this.packageData.weight = +(unit_weight * pieces / 1000).toFixed(3);
      },
      createProduct(product) {
        const productId = product ? product.id : 'new';
        window.open(`/product/${productId}`, '_blank');
      },
      openPackageTemplateNameDialog() {
        const namePlaceholder = this.$i18n.t('placeholders.enter_package_template_name');
        this.$swal.fire({
          title: this.$i18n.t(`dialogs.create_package_template`),
          html:
            `<input type="text" id="template-name" class="form-control">`,
          focusConfirm: false,
          onBeforeOpen: () => {
            document.getElementById('template-name').placeholder = namePlaceholder;
          },
          preConfirm() {
            return {
              name: document.getElementById('template-name').value
            }
          },
          showCancelButton: true,
          cancelButtonText: this.$i18n.t(`buttons.common.cancel`)
        }).then(result => {
          if (result.value) {
            this.addPackageTemplate(result.value)
          }
        });
      },
      async savePackage() {
        const payload = this.prepareSavedPackageData();
        const loader = this.$loading.show();
        if (this.packageData.isNew) {
          try {
            const response = await this.$http.post(`woodware/movement_data/`, payload).then(handlerResponse);
            this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
              this.$i18n.t(`notifications.packages.new_package_created`), 'success'));
            this.packageData = await {...this.packageData, ...response};
            delete this.packageData.isNew;
            this.fetchCallback();
            loader.hide();
          } catch (error) {
            notificationsRenderer(error.data, 'error');
            loader.hide();
            throw error.data;
          }
        } else {
          try {
            await this.$http.put(`woodware/movement_data/${this.packageData.id}/`, payload).then(handlerResponse);
            if (this.packageData.subpackages.length) {
              const currentSubPackage = this.packageData.subpackages[this.currentTabIndex];
              await this.saveSubPackageRequest(currentSubPackage);
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                this.$i18n.t(`notifications.packages.package_updated`), 'success'));
              this.fetchCallback();
              loader.hide();
            } else {
              this.fetchCallback();
              loader.hide();
            }
          } catch (error) {
            notificationsRenderer(error.data, 'error');
            loader.hide();
            throw error.data;
          }
        }
      },
      async save() {
        try {
          await this.savePackage();
        } catch (e) {
          console.log(e);
        }
      },
      createBasedOnChanges() {
        const payload = this.prepareSavedPackageData();
        this.$http.post(`woodware/create_movement_data_based_changes/`, payload).then(handlerResponse).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.new_package_created`), 'success'));
          this.fetchCallback();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      async openPackageForm(type) {
        await this.savePackage();
        delete this.packageData['non_editable_fields'];
        this.packageData.type = type;
        if (this.packageData.serial_nr) {
          ++this.packageData.serial_nr
        }
        this.packageData.comment = '';
        this.packageData.amount = 0;
        this.packageData.isNew = true;
        this.packageData.package_nr = '';
        this.$refs['package-creating-popover'].$emit('close');
        this.savePackage();
      },
      tabChanged(currentTabs, previousTabs) {
        if (this.packageData.type !== 'single') {
          if (previousTabs.length) {
            this.currentTabIndex = this.packageData.subpackages.length - 1;
          }
        } else {
          this.currentTabIndex = 0;
        }
      },
      addNewSubPackage() {
        const currentSubPackage = this.packageData.subpackages[this.currentTabIndex];
        const payload = {
          movement: this.operationId,
          parent: this.packageData.id,
          type: 'subpackage'
        };
        if (currentSubPackage) {
          const subPackageQuality = this.packageData.subpackages[this.currentTabIndex].quality;
          const thickness = this.packageData.subpackages[this.currentTabIndex].thickness;
          const serial_nr = this.packageData.subpackages[this.currentTabIndex].serial_nr;
          payload.quality = subPackageQuality && subPackageQuality.id;
          payload.thickness = thickness;
          if (serial_nr) {
            payload.serial_nr = Number(serial_nr) + 1;
          }
        }
        this.$http.post(`woodware/movement_data/`, payload).then(handlerResponse).then(response => {
          this.packageData.subpackages.push(response);
          this.fetchCallback();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      prepareSubPackageData(subPackage) {
        return {
          thickness: subPackage.thickness,
          length: subPackage.length,
          quality: subPackage.quality && subPackage.quality.id,
          amount: subPackage.amount,
          comment: subPackage.comment,
          serial_nr: subPackage.serial_nr || null
        }
      },
      saveSubPackageRequest(subPackage) {
        return new Promise((resolve, reject) => {
          const payload = this.prepareSubPackageData(subPackage);
          if (this.packageData.type === 'float') {
            payload.width_list = subPackage.width_list;
          } else if (this.packageData.type === 'mix') {
            payload.width = subPackage.width;
          }
          this.$http.put(`woodware/movement_data/${subPackage.id}/`, payload).then(handlerResponse).then((response) => {
            subPackage = {...subPackage, ...response};
            resolve();
          }).catch(error => {
              reject(error);
            }
          );
        })
      },
      async delayedSavingSubPackage(requestData) {
        await this.saveSubPackageRequest(requestData);
      },
      async createCopies() {
        await this.savePackage();
        const copies = Number(this.$refs['copies-count'].value);
        const payload = {
          packet: this.packageData.id,
          copies
        };
        this.$http.post(`woodware/movement_data/create_duplicate/`, payload).then(handlerResponse).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.count_packages_created`, {count: copies}), 'success'));
          this.fetchCallback();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      addPackageTemplate(data) {
        const payload = {
          ...data,
          product: this.packageData.product.id
        };
        if (payload.name) {
          this.$http.post(`woodware/product_templates/`, payload).then(handlerResponse).then(() => {
            this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
              this.$i18n.t(`notifications.packages.packages_added_to_favorite`), 'success'));
            this.$store.dispatch('woodware/loadProductTemplates');
          }).catch(error => notificationsRenderer(error.data, 'error'));
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_template_name`), ``, 'warn'));
        }
      },
      deletePackage() {
        this.$http.delete(`woodware/movement_data/${this.packageData.id}/`).then(handlerResponse).then(() => {
          this.$refs['PackageModal'].hide();
          this.fetchCallback();
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.package_deleted`), 'success'));
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      applyToAllPackages(paramName, key = 'id') {
        const applyParam = this.$i18n.t(`labels.common.${paramName}`).toLowerCase();
        if (this.packageData[paramName]) {
          const value = key ? this.packageData[paramName][key] : this.packageData[paramName];
          const title = this.$i18n.t(`dialogs.apply_to_all_confirm`, {applyParam})
          this.$swal.fire(this.prepareConfirmDialog(title))
            .then(result => {
              if (result.value) {
                const loader = this.$loading.show();
                const payload = {
                  [paramName]: value
                };
                this.$http.put(`woodware/update_packages_in_operation/${this.operationId}/`, payload).then(handlerResponse).then(() => {
                  this.fetchCallback();
                  this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                    this.$i18n.t(`notifications.packages.applied_param_in_operation`, {applyParam}), 'success'));
                  loader.hide();
                }).catch(error => {
                  notificationsRenderer(error.data, 'error');
                }).finally(() => {
                  loader.hide();
                });
              }
            })
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.select_value_for_applying`, {applyParam}),
            '', 'warn'));
        }
      },
      deleteSubPackage(subPackage) {
        this.$http.delete(`woodware/movement_data/${subPackage.id}/`).then(handlerResponse).then(() => {
          for (let i = 0; i < this.packageData.subpackages.length; i++) {
            if (this.packageData.subpackages[i].id === subPackage.id) {
              this.packageData.subpackages.splice(i, 1)
            }
          }
          this.fetchCallback();
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.subpackage_deleted`), 'success'));
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      addWidth(currentSubPackage, index) {
        const widthElem = this.$refs[`subpackage-width-${index}`][0];
        let widthValue = widthElem.value;
        if (widthValue) {
          const separator = ' ';
          if (widthValue.includes(separator)) {
            const widthValues = widthValue.split(separator).filter(item => item !== ''); // if has more than 1 space
            currentSubPackage.width_list = currentSubPackage.width_list.concat(widthValues);
          } else {
            widthValue = Number(widthValue);
            if (!isNaN(widthValue)) {
              currentSubPackage.width_list.push(widthValue);
            } else {
              this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_valid_width_width_list`), '', 'error'));
              return;
            }
          }
          this.sumTotalWidthDataForSubPackage(currentSubPackage);
          this.calculateSubPackageM3(currentSubPackage);
          widthElem.value = '';
        }
      },
      changeWidth(event, currentSubPackage, widthIndex, subPackageIndex) {
        const currentWidth = Number(event.target.value);
        if (event.target.value === '') {
          currentSubPackage.width_list.splice(widthIndex, 1);
          this.sumTotalWidthDataForSubPackage(currentSubPackage);
          this.calculateSubPackageM3(currentSubPackage);
          this.$nextTick(() => {
            const widthsList = this.$refs[`width-item-${subPackageIndex}`];
            if (widthsList.length) {
              widthsList[widthIndex - 1].focus();
            } else {
              this.$refs[`subpackage-width-${subPackageIndex}`][0].focus();
            }
          })
          return;
        }
        if (!isNaN(currentWidth)) {
          this.$set(currentSubPackage.width_list, widthIndex, currentWidth);
          this.sumTotalWidthDataForSubPackage(currentSubPackage);
          this.calculateSubPackageM3(currentSubPackage);
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_valid_width`), '', 'error'));
        }
      },
      calculateSubPackageM3(subPackage) {
        const {amount, thickness, width, length, total_width} = subPackage;
        if (this.packageData.type === 'float') {
          subPackage.m3 = (total_width * thickness * length / 1000000000).toFixed(3);
        } else if (this.packageData.type === 'mix') {
          subPackage.m3 = (amount * thickness * width * length / 1000000000).toFixed(3);
        }
      },
      sumTotalWidthDataForSubPackage(subPackage) {
        try {
          subPackage.total_width = subPackage.width_list.reduce((sum, current) => {
            return Decimal.add(sum, current);
          }, 0);
          if (subPackage.width_list.length) {
            subPackage.average_width = (subPackage.total_width / subPackage.width_list.length).toFixed(2);
          } else {
            subPackage.average_width = 0;
          }
        } catch (e) {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_valid_width`), '', 'error'));
        }
      },
      checkValidFormData(checkedFields, checkedData) {
        return checkedFields.filter((item) => {
          if (!isObject(checkedData[item.field])) { // if multiselect isn't empty it has object format data
            return Array.isArray(checkedData[item.field]) ? checkedData[item.field].length
              : Number(checkedData[item.field])
          } else {
            return checkedData[item.field];
          }
        }).length === checkedFields.length;
      },
      getNotFilledFields(checkedFields, checkedData) {
        return checkedFields.filter((item) => {
          if (!isObject(checkedData[item.field])) {
            return Array.isArray(checkedData[item.field]) ? !checkedData[item.field].length
              : !Number(checkedData[item.field]);
          }
        }).map(item => {
          if (item.label) {
            return item.label
          }
          return _.upperFirst(item.field);
        });
      },
      calculateDataForSubPackages() {
        this.packageData.subpackages.forEach((subPackage) => {
          this.sumTotalWidthDataForSubPackage(subPackage);
        });
      },
      isNotEditablePackageField(field) {
        if (this.packageData.non_editable_fields && this.packageData.non_editable_fields.length) {
          return this.packageData.non_editable_fields.includes(field);
        }
      },
      isDisabledSubpackageField({non_editable_fields}, field) {
        if (non_editable_fields && non_editable_fields.length) {
          return non_editable_fields.includes(field);
        }
      },
      isHiddenFields(field) {
        if (this.packageData.hidden_fields && this.packageData.hidden_fields.length) {
          return this.packageData.hidden_fields.includes(field);
        }
      },
      cleanAddingWidth() {
        for (let key in this.$refs) {
          if (this.$refs.hasOwnProperty(key) && key.includes('subpackage-width')) {
            if (this.$refs[key].length) {
              this.$refs[key][0].value = '';
            }
          }
        }
      },
      hiddenModal() {
        this.cleanAddingWidth();
      },
      prepareConfirmDialog(title, icon = 'question') {
        return {
          title,
          icon,
          showCancelButton: true,
          confirmButtonColor: '#1bc14d',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$i18n.t(`common_content.yes`),
          cancelButtonText: this.$i18n.t(`common_content.no`)
        }
      },
      closeModal() {
        this.$refs['PackageModal'].hide();
      }
    },
    mounted() {
      this.$root.$on('openPackageModal', async (data) => {
        this.packageData = {...this.initialPackageData};
        this.$store.cache.dispatch('generic/loadPackageTypes');
        this.$store.cache.dispatch('woodware/getWoodCertificates');
        this.$store.cache.dispatch('woodware/getWood');
        this.$store.cache.dispatch('woodware/getStockAddresses');
        this.$store.cache.dispatch('woodware/getQualitiesList');
        this.$store.cache.dispatch('woodware/loadHumidityList');
        this.$store.cache.dispatch('woodware/getGroupsWithHierarchy');
        this.$store.cache.dispatch('woodware/fetchPalletSizes');
        this.$store.cache.dispatch('woodware/fetchBagLogos');
        this.$store.cache.dispatch('woodware/fetchPelletDiameters');
        this.fetchPurchaseOrders();
        this.packageData = {...this.packageData, ...data};
        if (this.packageData.type !== 'single') {
          this.calculateDataForSubPackages();
        }
        if (this.$refs['PackageModal']) {
          this.$refs['PackageModal'].show();
          this.$nextTick(() => {
            const tabsPanel = document.querySelectorAll('.modal-dialog .nav-tabs')[0];
            if (tabsPanel) {
              tabsPanel.setAttribute('tabIndex', '100');
            }
          })
        }
      });
      this.$root.$on('closePackageModal', () => {
        this.$nextTick(() => {
          if (this.$refs['PackageModal']) {
            this.$refs['PackageModal'].hide();
          }
        });
      });
      this.$root.$on('savePackage', () => {
        this.savePackage();
      });
    },
    watch: {
      currentTabIndex(current, prev) {
        const previousSubPackage = this.packageData.subpackages[prev];
        if (previousSubPackage) {
          this.saveSubPackageRequest(previousSubPackage);
        }
      }
    },
    computed: {
      ...mapState('generic', ['packageTypes']),
      ...mapState('woodware', ['wood_certificates', 'profiles', 'partners', 'wood', 'stock_addresses', 'imprs',
        'qualities_list', 'humidity_list', 'groups', 'pallet_sizes', 'bag_logos', 'pellet_diameters'])
    },
    beforeDestroy() {
      this.$root.$off('openPackageModal');
      this.$root.$off('closePackageModal');
      this.$root.$off('savePackage');
    }
  }
</script>

<style scoped lang="scss">
  label {
    display: flex;
    align-items: center;
  }

  .row {
    margin-top: 6px;
  }

  .package-params {
    > div {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;

      > div, > input {
        width: 60%;
      }
    }

    &.single-params > div {
      > div, input {
        width: 75%;
      }

      .size-param {
        width: 95%;
      }
    }
  }

  .total-params {
    > div {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;

      > div, > input {
        width: 75%;
      }
    }

    &.single-params > div {
      > div, input {
        width: 75%;
      }
    }
  }

  .width-list {
    max-height: 180px;
    overflow-y: auto;

    input {
      min-height: 20px;
      height: 20px;
      margin-top: 1px;
      padding: 1px 0 1px 10px;
      border-radius: 0;

      &:active, &:focus {
        border: 1px solid #80bdff;
        box-shadow: none;
      }
    }
  }

  .warning-text {
    color: #fb8469;
    font-size: 13px;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/PackageModal.vue